import ActiveFilterSortPill from './ActiveFilterSortPill.component';

export default ActiveFilterSortPill;
